<td
  *ngIf="operationItems ? true : false"
  pFrozenColumn
  [frozen]="true"
  alignFrozen="left"
  [style]="'min-width:' + operationItemsWidth + 'px;' + 'max-width:' + operationItemsWidth + 'px;'"
  class="operation"
>

  <div class="flex align-items-center justify-content-between min-w-full">
    <mx-table-operation-button
      *ngFor="let item of fixButtonItems"
      [command]="item.command"
      [tooltip]="item.label"
      [icon]="item.icon"
      [styleClass]="item.styleClass"
      [loading]="item.loading"
      [disabled]="item.disabled"
      [spacing]="'mr-0'"
      [rowData]="rowData"
    >
    </mx-table-operation-button>
    <mx-table-operation-tiered-menu-button
      [visible]="visibleTiered"
      [items]="tieredItems"
    ></mx-table-operation-tiered-menu-button>
    <mx-table-operation-speed-dial
      [visible]="visibleSpeedDial"
      [items]="speedDialItems"
    ></mx-table-operation-speed-dial>
  </div>
</td>
<td
  *ngFor="let col of columns"
  [style]="
    'min-width:' +
    (col.width ? col.width + 'px;' : columnDefaultWidth + 'px;')  +
    (col.coloredCells
      ? 'background: ' +
        (rowData[col.field] | mxTableColoredCell: col.coloredCells)
      : '')
  "
  [ngClass]="{ 'font-semibold': col.coloredCells }"
  [pEditableColumn]="col.editable"

>
  <mx-table-cell
    class="flex w-full"
    [(value)]="rowData[col.field]"
    [column]="col"
  ></mx-table-cell>
</td>
